import React, { Component, ErrorInfo, ReactNode } from 'react';

interface IconErrorBoundaryProps {
    fallback?: ReactNode;
    children: ReactNode;
}

interface IconErrorBoundaryState {
    hasError: boolean;
}

export class IconErrorBoundary extends Component<IconErrorBoundaryProps, IconErrorBoundaryState> {
    constructor(props: IconErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_: Error): IconErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Error loading icon:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }

        return this.props.children;
    }
}